import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { newsEnabled } from '../config/features'

import Admin from '../components/controllers/AdminController.vue'
import Company from '../components/controllers/CompanyController.vue'
import CompanyView from '../components/controllers/CompanyViewController.vue'
import MarketingCompany from '../components/controllers/MarketingCompanyController.vue'
import MarketingCompanyView from '../components/controllers/MarketingCompanyViewController.vue'
import MarketingTask from '../components/controllers/MarketingTaskController.vue'
import News from '../components/controllers/NewsController.vue'
import Schedule from '../components/controllers/ScheduleController.vue'
import SignIn from '../components/controllers/SignInController.vue'
import SignUp from '../components/controllers/SignUpController.vue'
import Stats from '../components/controllers/StatsController.vue'
import Task from '../components/controllers/TaskController.vue'
import Virtual from '../components/controllers/VirtualController.vue'

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next()
        return
    }
    next('/sign-in')
}

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next()
        return
    }
    next('/')
}

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Task',
            component: Task,
            props: () => ({schedule: false}),
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/task/schedule',
            name: 'TaskSchedule',
            component: Task,
            props: () => ({schedule: true}),
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/sign-in',
            name: 'SignIn',
            component: SignIn,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/sign-up',
            name: 'SignUp',
            component: SignUp,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/admin',
            name: 'Admin',
            component: Admin,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/company',
            name: 'Company',
            component: Company,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/company/view/:id',
            name: 'CompanyView',
            component: CompanyView,
            props: route => ({id: Number.parseInt(route.params.id) || 0}),
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/marketing/company',
            name: 'MarketingCompany',
            component: MarketingCompany,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/marketing/company/view/:id',
            name: 'MarketingCompanyView',
            component: MarketingCompanyView,
            props: route => ({id: Number.parseInt(route.params.id) || 0}),
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/marketing/task',
            name: 'MarketingTask',
            component: MarketingTask,
            props: () => ({schedule: false}),
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/marketing/task/schedule',
            name: 'MarketingTask',
            component: MarketingTask,
            props: () => ({schedule: true}),
            beforeEnter: ifAuthenticated,
        },
        ...(newsEnabled ? [{
            path: '/news',
            name: 'News',
            component: News,
            beforeEnter: ifAuthenticated,
        }] : []),
        {
            path: '/schedule',
            name: 'Schedule',
            component: Schedule,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/stats',
            name: 'Stats',
            component: Stats,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/virtual',
            name: 'Virtual',
            component: Virtual,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '*',
            beforeEnter: (to, from, next) => {
                next('/')
            },
        }
    ]
})
